/**
 * Created by Z179603 on 8/9/2016.
 */
'use strict';

angular.module('cvsApp')
    .factory("addDataService", ['loggerService', function(loggerService) {

        var _accountDetailsGuest={
            accountNumber:"",
            activeFlag:"ACTIVE",
            billingAddress:{
                addressLine1:"",
                addressLine2:"",
                city:"",
                state:"",
                zipCode:"",
                zipCodeExt:""
            },
            cardholder:{
                firstName:"",
                lastName:"",
                middleName:""
            },
            createdBy:"",
            expiredIndicator:"false",
            expiryDate:{
                month:"",
                year:""
            },
            overrideIndicator:"",
            payment:{
                amount:"",
                frequency:"",
                fsaIndicator:"",
                method:"",
                type:""
            },
            paymentCurrency:"USD",
            paymentIndicator:"",
            paymentMethodId:"",
            primaryMethod:"",
            relationshipToCardHolder:"",
            routingNumber:"",
            transactionMode:"ADD"

        };
        var _newAccountDetails;
        var _editModeStarted=false;

        return {
            getNewMOP:function(){
                return _newAccountDetails;
            },
            isEditedModeStarted:function(){
                return _editModeStarted;
            },
            setNewMop:function(accountDetailsGuest){
                _newAccountDetails=accountDetailsGuest;
                _editModeStarted=true;
            },
            removeEditedModeStarted:function(){
                _editModeStarted=false;
            }
        }

    }]);